import $ from 'jquery';
import 'what-input';



console.clear();

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';


$(document).foundation();

function _isSmall() {
    // console.log(Foundation.MediaQuery.current)
    return Foundation.MediaQuery.only('small');
}
function isMobile() {
    return mobileSniff();// /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(window.navigator.userAgent);
}
function iPhoneSniff() {
    return /iP(ad|hone|od).*OS/.test(window.navigator.userAgent);
}
function androidSniff() {
    return /Android/.test(window.navigator.userAgent);
}
function mobileSniff() {
    return iPhoneSniff() || androidSniff();
}
const isSmall = _isSmall();

navigator.sayswho = (function(){
    let ua= navigator.userAgent, tem, 
    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE '+(tem[1] || '');
    }
    if(M[1]=== 'Chrome'){
        tem= ua.match(/\bOPR\/(\d+)/)
        if(tem!= null) return 'Opera '+tem[1];
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    return M.join(' ');
})();
let browser = navigator.sayswho;
// console.log(navigator)
$('body').addClass(browser.split(' ')[0].toLowerCase()).addClass(navigator.platform.toLowerCase());
let _width = $(window).width();
let _height = $(window).height();
$('body').attr('data-width', _width);
$('body').attr('data-height', _height);


import { preloadImages } from '../utils';
import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
import CSSRulePlugin from 'gsap/CSSRulePlugin';
import Draggable from 'gsap/Draggable';
import InertiaPlugin from 'gsap/InertiaPlugin';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(SplitText, CSSRulePlugin, Draggable, InertiaPlugin, ScrollTrigger);
gsap.registerEffect({
    name: "counter",
    extendTimeline: true,
    defaults: {
      end: 0,
      duration: 0.5,
      ease: "power1",
      increment: 1,
    },
    effect: (targets, config) => {
        let tl = gsap.timeline()
        let num = targets[0].innerText.replace(/\,/g,'')
        targets[0].innerText = num
        
        tl.to(targets, {duration:config.duration, 
                innerText:config.end, 
                //snap:{innerText:config.increment},
                modifiers:{
                    innerText:function(innerText){
                        return  gsap.utils.snap(config.increment, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                },
                ease:config.ease}, 0)
        
        return tl
    }
});

function restoreSplitText(arr) {
    arr.forEach(el => el.revert());
}


$('.lazy-fit').on('bestfit', function() {
    var css;
    var ratio = $(this).width() / $(this).height();
    var pratio = $(this).parents(".carousel-comm-left__item").width() / $(this).parents(".carousel-comm-left__item").height();
    if (isMobile()) {
        if ($(this).get(0).classList.contains('no-resize')) {
            css = {width:'auto', height:'100%'};
        } else {
            css = {width:'100%', height:'auto'};
        }
    } else {
        if (ratio >= pratio) {
            css = {width:'auto', height:'100%'};
        } else {
            css = {width:'100%', height:'auto'};
        }
    }
    $(this).css(css);
}).on('load', function() {
    $(this).trigger('bestfit');
}).trigger('bestfit');

let resizeTime,
    timeout = false,
    delta = 200;
window.addEventListener('resize', e => {
    resizeTime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(makeResize, delta);
    }
    $('.video-container video').get(0).pause();
    _width = $(window).width();
    _height = $(window).height();
    $('body').attr('data-width', _width);
    $('body').attr('data-height', _height);
});
function makeResize() {
    if (new Date() - resizeTime < delta) {
        setTimeout(makeResize, delta);
    } else {
        timeout = false;
        $('img').trigger('bestfit');
        $('video').trigger('bestfit');
        if ($('.video-container video').length) $('.video-container video').get(0).play();
        rebuildStats();
    }
}
  

$('.homepage-hero-video .video-container').each(function(){
    var attr_mp4 = $(this).data('videosrc-mp4');
    // var attr_webm = $(this).data('videosrc-webm');
    if ((typeof attr_mp4 !== typeof undefined && attr_mp4 !== false) || (typeof attr_webm !== typeof undefined && attr_webm !== false)) {
        var videosrc_mp4 = $(this).data('videosrc-mp4');
        // var videosrc_webm = $(this).data('videosrc-webm');
        const poster = $(this).data('poster') ? $(this).data('poster') : '';
        const id = $(this).data('id') ? $(this).data('id') : '';
        $(this).append('<video class="no-resize1" muted="muted" id="'+id+'" poster="'+poster+'" width="100%" autoplay="autoplay" playsinline crossorigin canplaythrough preload="auto"><source src="'+videosrc_mp4+'" type="video/mp4"></video>');
    }
});
$('.homepage-hero-video video').attr('loop', true);
$('.homepage-section-video video').each(function(){
    $(this).attr('loop', true);
});

// cover fit hero videos on load
$('.video-container video').on('bestfit', function() {
    let css;
    let ratio = this.videoWidth / this.videoHeight;
    let pratio = $(this).parents(".section").width() / $(this).parents(".section").height();
    if (!isMobile()) {
        if (ratio >= pratio) {
            css = {width:'auto', height:'100%'};
        } else {
            // if ($(this)[0].videoWidth >= $(document).width()) {
            css = {width:'100%', height:'auto'};
            // } else {
            // css = {width:'100%', height:'100%'};
            // }
        }
    } else {
        if (!$(this).hasClass("no-resize")) {
            css = {width:'auto', height:'100%'};
        } else {
            css = {width:'100%', height:'auto'};
        }
    }
    $(this).css(css);
    // console.log(css);
}).on('loadeddata', function() {
    // console.log("video loaded");
    $(this).trigger('bestfit');
    $(this).get(0).play();
    if(this.id == 'heroVideo') gsap.delayedCall(1, powerVideo);
}).trigger('bestfit');

function powerVideo() {
    if ($('.video-container video').length) {
        // $('video').trigger('bestfit');
        $('.video-container video').get(0).play();
        // gsap.to(document.querySelector("#heroVideo"), {duration: 2.6, autoAlpha: 1, delay: 0.5}); // shows hero video
        gsap.delayedCall(0.4, section0);
    }
}


// const jsonexport = require('jsonexport/dist');
window.addEventListener('load', e => {
    
  gsap.to('body', {duration: 0.6, autoAlpha: 1, ease: 'sine.out'});



});

if (document.querySelector('body').classList.contains('HomePage')) {

    // Preload all images
    preloadImages('.image').then(() => {
        // remove loader (loading class) 
        document.body.classList.remove('loading');
    });
  
}



// init slides
const slides = document.querySelectorAll(".section");
const container = document.querySelector("#panelWrap");
let dots = document.querySelector(".dots");
const dotAnim = gsap.timeline({paused:true});
let toolTips = document.querySelectorAll(".toolTip");
let oldSlide = 0;
let activeSlide = 0;
let navDots = [];
let dur = 0.9;
let offsets = [];
let toolTipAnims = [];
let ih = window.innerHeight;
let sectionIsAnimating = false, sectionIsScrolling = false;
let sectionReady = [];
let oldStory = 0, currStory = 0, playingStories = false;
const bgAnimTime = 4;

if (Foundation.MediaQuery.is('medium')) {
    console.log('medium up screens, is small:', isSmall);

    // create nev dots and add tooltip listeners
    for (let i = 0; i < slides.length; i++) {
        let tl = gsap.timeline({paused:true, reversed:true});
        let newDot = document.createElement("div");
        newDot.className = "dot";
        newDot.index = i;
        navDots.push(newDot);
        newDot.addEventListener("click", slideAnim);
        newDot.addEventListener("mouseenter", dotHover);
        newDot.addEventListener("mouseleave", dotHover);
        dots.appendChild(newDot);
        offsets.push(-slides[i].offsetTop);
        tl.to(toolTips[i], {duration: 0.25, opacity:1, ease:'none'});
        toolTipAnims.push(tl);
        sectionReady[i] = false;
    }

    // get elements positioned
    gsap.set(".dots", {yPercent:-50});
    gsap.set(".toolTips", {yPercent:-50});
    
    // side screen animation with nav dots
    dotAnim.to(
        ".dot",
        {
            stagger: { each: 1, yoyo: true, repeat: 1 },
            backgroundColor: "#f19d38",
            ease: "none"
        },
        0.5
    );
    dotAnim.time(1);

    window.addEventListener("wheel", slideAnim);
    window.addEventListener("resize", newSize);

    newSize();

} else {
    console.log('small screens, is small:', isSmall);
    slides.forEach((section, idx) => {
        ScrollTrigger.create({
            trigger: section,
            start: 'top 75%',
            end: 'bottom 50%',
            toggleClass: 'active',
            onUpdate: self => {
                const s = document.querySelector('.section.active');
                if (s) {
                    activeSlide = parseInt(s.id.substring(2));
                    animateSlide();
                }
            },
            onToggle: self => {
                const s = document.querySelector('.section.active');
                const p = document.querySelectorAll('.section');
                p.forEach(v => {
                    const d = v.querySelector('video');
                    if (d) {
                        d.pause();
                    }
                });
                if (s) {
                    const vid = s.querySelector('video');
                    if (vid) {
                        vid.play();
                    }
                }
            }
            // markers: true,
            // id: section.id,
        });

        sectionReady[idx] = false;
    });

    // const wrap = document.querySelector('#panelWrap');
    window.addEventListener("scroll", e => {
        if (window.scrollY > 50) {
            document.body.classList.remove('home');
        } else {
            document.body.classList.add('home');
        }
    });
}

// tooltips hovers
function dotHover() {
    toolTipAnims[this.index].reversed() ? toolTipAnims[this.index].play() : toolTipAnims[this.index].reverse();
}
// figure out which of the 4 nav controls called the function
function slideAnim(e) {

    if (sectionIsAnimating || sectionIsScrolling) return;
    sectionIsScrolling = true;
    oldSlide = activeSlide;
    // dragging the panels
    if (this.id === "dragger") {
        activeSlide = offsets.indexOf(this.endY);
    } else {
        if (gsap.isTweening(container)) {
            return;
        }
        // up/down arrow clicks
        if (this.id === "downArrow" || this.id === "upArrow") {
            activeSlide = this.id === "downArrow" ? (activeSlide += 1) : (activeSlide -= 1);
        // click on a dot
        } else if (this.className === "dot") {
            activeSlide = this.index;
        // scrollwheel
        } else {
            // console.log(e.deltaY)
            // if (Math.abs(e.deltaY) < 1) return;
            activeSlide = e.deltaY > 0 ? (activeSlide += 1) : (activeSlide -= 1);
        }
    }
    // make sure we're not past the end or beginning slide
    activeSlide = activeSlide < 0 ? 0 : activeSlide;
    activeSlide = activeSlide > slides.length - 1 ? slides.length - 1 : activeSlide;
    if (oldSlide === activeSlide) {
        sectionIsAnimating = false;
        sectionIsScrolling = false;
        return;
    }
    // console.log(activeSlide)
    // if we're dragging we don't animate the container
    if (this.id != "dragger") {
        gsap.to(container, {duration: dur, y: offsets[activeSlide], ease:"sine.inOut", onUpdate:tweenDot, onComplete:animateSlide });
    }
}


gsap.set(".hideMe", {opacity:1});

// resize all panels and refigure draggable snap array
function newSize() {
    offsets = [];
    ih = window.innerHeight;
    gsap.set("#panelWrap", { height: slides.length * ih });
    gsap.set(slides, { height: ih });
    for (let i = 0; i < slides.length; i++) {
        offsets.push(-slides[i].offsetTop);
    }
    gsap.set(container, { y: offsets[activeSlide] });
    // dragMe[0].vars.snap = offsets;
}

// tween the dot animation as the draggable moves
function tweenDot() {
    gsap.set(dotAnim, {
        time: Math.abs(gsap.getProperty(container, "y") / ih) + 1
    });
}

function animateSlide() {
    document.body.classList.remove('home');
    switch (activeSlide) {
        case 0:
            section0();
            document.body.classList.add('home');
            break;
        case 1:
            section1();
            break;
        case 2:
            section2();
            break;
        case 3:
            section3();
            break;
        case 4:
            section4();
            break;
        case 5:
            section5();
            break;
        case 6:
            section6();
            break;
        case 7:
            section7();
            break;
        case 8:
            section8();
            break;
        case 9:
            section9();
            break;
        case 10:
            section10();
            break;
        case 11:
            section11();
            break;
    }
    sectionIsScrolling = false;
}

// section0();

function initStats(sectionId) {
    const section = document.querySelector(sectionId);

    const yearsWrapper = section.querySelector('.years-slider');
    const years = yearsWrapper.querySelectorAll('li');
    const volume = section.querySelector('.stats-years .volume');
    const bbox = yearsWrapper.getBoundingClientRect();
    let firstData;
    years.forEach((li, index) => {
        const graph = document.createElement('SPAN');
        li.appendChild(graph);
        li.onclick = (ev) => {
            years.forEach(y => {y.classList.remove('active')});
            const ruleA = CSSRulePlugin.getRule(sectionId + ' .years-slider::after');
            const that = ev.target;
            that.classList.add('active');
            const data = that.dataset['volume'];
            gsap.effects.counter(volume, {end: data, increment: 1, duration: 0.6});
            const bboxLi = that.getBoundingClientRect();
            gsap.to(ruleA, {duration: 0.4, cssRule: {width: that.clientWidth, left: bboxLi.left - bbox.left}, ease: 'expo.out'});
        }
        if (li.classList.contains('active')) {
            const ruleA = CSSRulePlugin.getRule(sectionId + ' .years-slider::after');
            const bboxLi = li.getBoundingClientRect();
            const data = li.dataset['volume'];
            firstData = data;
            gsap.to(ruleA, {duration: 0.4, cssRule: {width: li.clientWidth, left: bboxLi.left - bbox.left}, ease: 'expo.out'});
        }
    });
    return firstData;
}
function animateStats(sectionId) {
    const section = document.querySelector(sectionId);
    const yearsWrapper = section.querySelector('.years-slider');
    const years = yearsWrapper.querySelectorAll('li');
    const maxHeight = isSmall ? 90 : 120;
    let maxVolume = 0;
    years.forEach((li, index) => {
        const data = parseFloat(li.dataset['volume']);
        maxVolume = Math.max(maxVolume, data);
    });
    years.forEach((li, index) => {
        const data = parseFloat(li.dataset['volume']);
        const _height = maxHeight * data / maxVolume;
        gsap.to(li.querySelector('span'), {duration: 0.4, height: _height, ease: 'sine.out'});
    });
}
function rebuildStats() {
    const sections = document.querySelectorAll('.section');
    sections.forEach(section => {
        const sectionId = section.id;
        const yw = section.querySelector('.years-slider');
        if (yw) {
            const years = yw.querySelectorAll('li');
            const bbox = yw.getBoundingClientRect();
            const volume = section.querySelector('.stats-years .volume');
            years.forEach((li, index) => {
                li.onclick = (ev) => {
                    years.forEach(y => {y.classList.remove('active')});
                    const ruleA = CSSRulePlugin.getRule('#' + sectionId + ' .years-slider::after');
                    const that = ev.target;
                    that.classList.add('active');
                    const data = that.dataset['volume'];
                    gsap.effects.counter(volume, {end: data, increment: 1, duration: 0.6});
                    const bboxLi = that.getBoundingClientRect();
                    gsap.to(ruleA, {duration: 0.4, cssRule: {width: that.clientWidth, left: bboxLi.left - bbox.left}, ease: 'expo.out'});
                }
                if (li.classList.contains('active')) {
                    const ruleA = CSSRulePlugin.getRule('#' + sectionId + ' .years-slider::after');
                    const bboxLi = li.getBoundingClientRect();
                    gsap.set(ruleA, {cssRule: {width: li.clientWidth, left: bboxLi.left - bbox.left}});
                }
            });
        }
    });
}

import Flickity from 'flickity';
require('flickity-fade');
require('flickity-as-nav-for');
function initVoicesCarousel() {
    let photos = new Flickity('.photos-carousel', {
        // autoPlay: true,
        prevNextButtons: false,
        contain: true,
        percentPosition: false,
        asNavFor: '.voices-quotes-carousel',
        draggable: false,
    });
    let quotes = new Flickity('.voices-quotes-carousel', {
        fade: true,
        pageDots: false,
        prevNextButtons: false,
        cellSelector: '.carousel-quote-item',
        draggable: false,
        // asNavFor: '.photos-carousel',
    });
    const prev = document.querySelector('.prev-voice');
    const next = document.querySelector('.next-voice');
    prev.addEventListener('click', () => {
        photos.previous();
        quotes.previous();
    });
    next.addEventListener('click', () => {
        photos.next();
        quotes.next();
    });
}

// section 0 animations
function section0() {
    if (sectionIsAnimating || sectionReady[0]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const sectionId = '#s-0';
    const section = document.querySelector(sectionId);

    // Get the core elements
    let clone = section.getElementsByClassName("clone");
    const subtitle = section.querySelectorAll('p.lead1');

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });
    gsap.to(document.querySelector("#heroVideo"), {duration: 0.6, autoAlpha: 1, delay: 0}); // shows hero video

    let splitHeader = new SplitText(clone, { type: "chars", charsClass: "char"});
    let splitInfo = new SplitText(sectionId + ' p.info', {type:"words"});
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');

    // Set up vars
    let animTime = 0.6; // baseline animation time for each stagger
    let width = document.documentElement.clientWidth; // viewport width
    let height = document.documentElement.clientHeight; // viewport height
    // let depth = -width/8; // rotation depth based on viewport width
    // let tOrigin = "50% 50% "+depth; // transform origin as a factor of viewport width to allow for different device widths


    // Init 3D perspective
    gsap.set(clone, { perspective:700, transformStyle:"preserve-3d"});
    gsap.set(splitHeader.chars, {transformOrigin: "50% 100%"});

    const svgs = section.getElementsByClassName("svg");
    const svg2 = section.getElementsByClassName("svg2");
    const img = section.getElementsByClassName("image");

    const _h1_f = isSmall ? -height/2.75-40 : -height/2.75-40;
    const _h1_t = isSmall ? -height/2.75-140 : -height/2.75-140;
    
    const _h2_f = isSmall ? -height/3-40 : -height/2-40;
    const _h2_t = isSmall ? -height/3-140 : -height/2-140;

    const _h3_f = isSmall ? -height/4+40 : -height/4.5+40;
    const _h3_t = isSmall ? -height/4+20 : -height/4.5+20;


    // Animate Timeline
    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[0] = true; restoreSplitText([splitHeader])}});

    linesTL.fromTo(clone, {y:_h1_f}, {duration:animTime, y:_h1_t, ease:'power2.out'})
        .fromTo(splitHeader.chars, {autoAlpha:0, rotationX:90, y:"-=20"}, {duration:animTime, autoAlpha:1, rotationX:0, y:0, ease:'power4.out', stagger:0.08}, 0)

        .fromTo(subtitle, {autoAlpha:0, y:_h2_f}, {duration:animTime*2, autoAlpha:1, y:_h2_t, ease:'power4.out'}, 1.2)
        .fromTo(splitInfo.words, {autoAlpha:0, y:_h3_f}, {duration:0.4, autoAlpha:1, y:_h3_t, stagger:0.04}, 1.6)
        .from(scroll, {y:200, duration:1, autoAlpha:0, ease:'power4.out'}, 2.3)
        .to(scrollLine, {height:"20%", duration:1, ease:"power4.out"}, 2.5)

}

// section 1 animations
function section1() {
    if (sectionIsAnimating || sectionReady[1]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const section = document.querySelector('#s-1');
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');

    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[1] = true}});
    linesTL.fromTo(scroll, {y:200, autoAlpha:0}, {duration:1, y: 0, autoAlpha: 1, ease:'power4.out'}, 0.4)
        .to(scrollLine, {height:"30%", duration:1, ease:"power4.out"}, 0.5)
}

// section 2 animations - image section / outpatient visits
function section2() {

    if (sectionIsAnimating || sectionReady[2]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const sectionId = '#s-2';
    const section = document.querySelector(sectionId);

    const volume = section.querySelector('.stats-years .volume');
    let firstData = initStats(sectionId);

    // Get the core elements
    let clone = section.getElementsByClassName("clone");
    const subtitle = section.querySelectorAll('p.lead');

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });
    gsap.to(document.querySelector(sectionId + " video"), {duration: 0.6, autoAlpha: 1, delay: 1.5}); // shows hero video

    let splitHeader = new SplitText(clone, { type: "chars", charsClass: "char"});
    let splitInfo = new SplitText(sectionId + ' p.info', {type:"words"});
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');
    const stats = section.querySelector('.stats-years');

    // Set up vars
    let animTime = 0.7; // baseline animation time for each stagger
    let width = document.documentElement.clientWidth; // viewport width
    let height = document.documentElement.clientHeight; // viewport height


    // Init 3D perspective
    gsap.set(clone, { perspective:700, transformStyle:"preserve-3d"});
    gsap.set(splitHeader.chars, {transformOrigin: "50% 100%"});

    const bg = section.getElementsByClassName("bg-element");

    const _h1_f = isSmall ? 0 : -height/4-40;
    const _h1_t = isSmall ? 0 : -height/4.5-50;
    
    const _h2_f = isSmall ? 0 : -height/7.5;
    const _h2_t = isSmall ? 0 : -height/7.5-50;

    const _h3_f = isSmall ? 0 : -height/12.8;
    const _h3_t = isSmall ? 0 : -height/12.8-15;

    // Animate Timeline
    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[2] = true; restoreSplitText([splitHeader])}});
    linesTL.fromTo(clone, {y:_h1_f}, {duration:animTime, y:_h1_t, ease:'power2.out'})
        .fromTo(splitHeader.chars, {autoAlpha:0, rotationX:90, y:"-=20"}, {duration:animTime, autoAlpha:1, rotationX:0, y:0, ease:'power4.out', stagger:0.08}, 0)

        .fromTo(subtitle, {autoAlpha: 0, y:_h2_f}, {duration: animTime*2, autoAlpha: 1, y:_h2_t, ease:'power2.out'}, 1.2)
        .fromTo(splitInfo.words, {autoAlpha: 0, y:_h3_f}, {duration: 0.6, autoAlpha: 1, y:_h3_t, stagger: 0.04, ease: 'power2.out'}, 1.6)

        .fromTo(stats, {autoAlpha: 0, y:"+=5"}, {duration: 0.5, autoAlpha: 1, y: 0}, 2.6)
        .counter(volume, {end: firstData, increment: 1, duration: 0.6}, 2.8)
        .from(scroll, {y:200, duration:1, autoAlpha:0, ease:'power4.out'}, 3.4)
        .to(scrollLine, {height:"60%", duration:1, ease:"power4.out"}, 3.5)
        .fromTo(bg, {autoAlpha:0}, {autoAlpha: 1, duration: bgAnimTime, ease:'power4.out'}, 0);
    gsap.delayedCall(3.0, animateStats, [sectionId]);

}

// section 3 animations - video section / home visits
function section3() {

    if (sectionIsAnimating || sectionReady[3]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const sectionId = '#s-3';
    const section = document.querySelector(sectionId);

    const volume = section.querySelector('.stats-years .volume');
    let firstData = initStats(sectionId);

    // Get the core elements
    let clone = section.getElementsByClassName("clone");
    const subtitle = section.querySelectorAll('p.lead');

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });
    gsap.to(document.querySelector(sectionId + " video"), {duration: 0.6, autoAlpha: 1, delay: 1.5}); // shows hero video

    let splitHeader = new SplitText(clone, { type: "chars", charsClass: "char"});
    let splitInfo = new SplitText(sectionId + ' p.info', {type:"words"});
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');
    const stats = section.querySelector('.stats-years');

    // Set up vars
    let animTime = 0.6; // baseline animation time for each stagger
    let width = document.documentElement.clientWidth; // viewport width
    let height = document.documentElement.clientHeight; // viewport height


    // Init 3D perspective
    gsap.set(clone, { perspective:700, transformStyle:"preserve-3d"});
    gsap.set(splitHeader.chars, {transformOrigin: "50% 100%"});

    const bg = section.getElementsByClassName("bg-element");

    const _h1_f = isSmall ? 0 : -height/4-40;
    const _h1_t = isSmall ? 0 : -height/4.5-50;
    
    const _h2_f = isSmall ? 0 : -height/7.5;
    const _h2_t = isSmall ? 0 : -height/7.5-50;

    const _h3_f = isSmall ? 0 : -height/12.8;
    const _h3_t = isSmall ? 0 : -height/12.8-15;


    // Animate Timeline
    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[3] = true}});
    linesTL.fromTo(clone, {y:_h1_f}, {duration:animTime, y:_h1_t, ease:'power2.out'})
        .fromTo(splitHeader.chars, {autoAlpha:0, rotationX:90, y:"-=20"}, {duration:animTime, autoAlpha:1, rotationX:0, y:0, ease:'power4.out', stagger:0.08}, 0)

        .fromTo(subtitle, {autoAlpha: 0, y:_h2_f}, {duration: animTime*2, autoAlpha: 1, y:_h2_t, ease:'power2.out'}, 1.2)
        .fromTo(splitInfo.words, {autoAlpha: 0, y:_h3_f}, {duration: 0.6, autoAlpha: 1, y:_h3_t, stagger: 0.04, ease: 'power2.out'}, 1.6)

        .fromTo(stats, {autoAlpha: 0, y:"+=5"}, {duration: 0.5, autoAlpha: 1, y: 0}, 2.6)
        .counter(volume, {end: firstData, increment: 1, duration: 0.6}, 2.8)
        .from(scroll, {y:200, duration:1, autoAlpha:0, ease:'power4.out'}, 3.4)
        .to(scrollLine, {height:"60%", duration:1, ease:"power4.out"}, 3.5)
        .fromTo(bg, {autoAlpha:0}, {autoAlpha: 1, duration: bgAnimTime, ease:'power4.out'}, 0);
        gsap.delayedCall(3.0, animateStats, [sectionId]);

}

// section 4 animations - video section / Safe, facility-based deliveries
function section4() {

    if (sectionIsAnimating || sectionReady[4]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const sectionId = '#s-4';
    const section = document.querySelector(sectionId);

    const volume = section.querySelector('.stats-years .volume');
    let firstData = initStats(sectionId);

    // Get the core elements
    let clone = section.getElementsByClassName("clone");
    const subtitle = section.querySelectorAll('p.lead');

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });
    gsap.to(document.querySelector(sectionId + " video"), {duration: 0.6, autoAlpha: 1, delay: 1.5}); // shows hero video

    let splitHeader = new SplitText(clone, { type: "chars", charsClass: "char"});
    let splitInfo = new SplitText(sectionId + ' p.info', {type:"words"});
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');
    const stats = section.querySelector('.stats-years');

    // Set up vars
    let animTime = 0.7; // baseline animation time for each stagger
    let width = document.documentElement.clientWidth; // viewport width
    let height = document.documentElement.clientHeight; // viewport height


    // Init 3D perspective
    gsap.set(clone, { perspective:700, transformStyle:"preserve-3d"});
    gsap.set(splitHeader.chars, {transformOrigin: "50% 100%"});

    const bg = section.getElementsByClassName("bg-element");

    const _h1_f = isSmall ? 0 : -height/4-40;
    const _h1_t = isSmall ? 0 : -height/4.5-50;
    
    const _h2_f = isSmall ? 0 : -height/7.5;
    const _h2_t = isSmall ? 0 : -height/7.5-50;

    const _h3_f = isSmall ? 0 : -height/12.8;
    const _h3_t = isSmall ? 0 : -height/12.8-15;


    // Animate Timeline
    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[4] = true}});
    linesTL.fromTo(clone, {y:_h1_f}, {duration:animTime, y:_h1_t, ease:'power2.out'})
        .fromTo(splitHeader.chars, {autoAlpha:0, rotationX:90, y:"-=20"}, {duration:animTime, autoAlpha:1, rotationX:0, y:0, ease:'power4.out', stagger:0.08}, 0)

        .fromTo(subtitle, {autoAlpha: 0, y:_h2_f}, {duration: animTime*2, autoAlpha: 1, y:_h2_t, ease:'power2.out'}, 1.2)
        .fromTo(splitInfo.words, {autoAlpha: 0, y:_h3_f}, {duration: 0.6, autoAlpha: 1, y:_h3_t, stagger: 0.04, ease: 'power2.out'}, 1.6)

        .fromTo(stats, {autoAlpha: 0, y:"+=5"}, {duration: 0.5, autoAlpha: 1, y: 0}, 2.6)
        .counter(volume, {end: firstData, increment: 1, duration: 0.6}, 2.8)
        .from(scroll, {y:200, duration:1, autoAlpha:0, ease:'power4.out'}, 3.4)
        .to(scrollLine, {height:"60%", duration:1, ease:"power4.out"}, 3.5)
        .fromTo(bg, {autoAlpha:0}, {autoAlpha: 1, duration: bgAnimTime, ease:'power4.out'}, 0);
        gsap.delayedCall(3.0, animateStats, [sectionId]);

}

// section 5 animations - image section / Patients on antiretroviral therapy
function section5() {

    if (sectionIsAnimating || sectionReady[5]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const sectionId = '#s-5';
    const section = document.querySelector(sectionId);

    const volume = section.querySelector('.stats-years .volume');
    let firstData = initStats(sectionId);

    // Get the core elements
    let clone = section.getElementsByClassName("clone");
    const subtitle = section.querySelectorAll('p.lead');

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });
    // gsap.to(document.querySelector(sectionId + " video"), {duration: 0.6, autoAlpha: 1, delay: 1.5}); // shows hero video

    let splitHeader = new SplitText(clone, { type: "chars", charsClass: "char"});
    let splitInfo = new SplitText(sectionId + ' p.info', {type:"words"});
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');
    const stats = section.querySelector('.stats-years');

    // Set up vars
    let animTime = 0.7; // baseline animation time for each stagger
    let width = document.documentElement.clientWidth; // viewport width
    let height = document.documentElement.clientHeight; // viewport height


    // Init 3D perspective
    gsap.set(clone, { perspective:700, transformStyle:"preserve-3d"});
    gsap.set(splitHeader.chars, {transformOrigin: "50% 100%"});

    const svgs = section.getElementsByClassName("svg");
    const svg2 = section.getElementsByClassName("svg2");
    const img = section.getElementsByClassName("image");
    const bg = section.getElementsByClassName("bg-element");

    const _h1_f = isSmall ? 0 : -height/4-40;
    const _h1_t = isSmall ? 0 : -height/4.5-50;
    
    const _h2_f = isSmall ? 0 : -height/7.5;
    const _h2_t = isSmall ? 0 : -height/7.5-50;

    const _h3_f = isSmall ? 0 : -height/12.8;
    const _h3_t = isSmall ? 0 : -height/12.8-15;


    // Animate Timeline
    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[5] = true}});
    linesTL.fromTo(clone, {y:_h1_f}, {duration:animTime, y:_h1_t, ease:'power2.out'})
        .fromTo(splitHeader.chars, {autoAlpha:0, rotationX:90, y:"-=20"}, {duration:animTime, autoAlpha:1, rotationX:0, y:0, ease:'power4.out', stagger:0.08}, 0)

        .fromTo(subtitle, {autoAlpha: 0, y:_h2_f}, {duration: animTime*2, autoAlpha: 1, y:_h2_t, ease:'power2.out'}, 1.2)
        .fromTo(splitInfo.words, {autoAlpha: 0, y:_h3_f}, {duration: 0.6, autoAlpha: 1, y:_h3_t, stagger: 0.04, ease: 'power2.out'}, 1.6)

        .fromTo(svgs, {y:"+=15", autoAlpha:0}, {duration: 0.7, y: 0, autoAlpha: 1, stagger: 0.1, ease: 'power4.out'}, 2)
        .fromTo(img, {y:"+5", autoAlpha:0}, {duration:1, y:0, autoAlpha:1, ease:"power4.out"}, 2.2)
        .fromTo(svg2, {autoAlpha:0, rotation:180}, {duration:0.6, autoAlpha:1, rotation:0, ease:'power4.out'}, 2.6)
        .fromTo(stats, {autoAlpha: 0, y:"+=5"}, {duration: 0.5, autoAlpha: 1, y: 0}, 2.6)
        .counter(volume, {end: firstData, increment: 1, duration: 0.6}, 2.8)
        .from(scroll, {y:200, duration:1, autoAlpha:0, ease:'power4.out'}, 3.4)
        .to(scrollLine, {height:"60%", duration:1, ease:"power4.out"}, 3.5)
        .fromTo(bg, {autoAlpha:0}, {autoAlpha: 1, duration: bgAnimTime, ease:'power4.out'}, 0);
        gsap.delayedCall(3.0, animateStats, [sectionId]);

    // Rotate final text on mouse move
    section.addEventListener("mousemove", onMouseMove);

    function onMouseMove(e) {
        let sxPos = (e.pageX / width*100 - 50)*2 ;
        let syPos = (e.pageY / height*100 - 50)*2;
        gsap.to(img, {
            duration: 3,
            rotationY: 0.04 * sxPos,
            // rotationX: -0.04 * syPos,
            transformOrigin: "center center -800",
            ease: 'expo.out'
        });
    }
}

// section 6 animations - more stats section / More Stats
function section6() {

    if (sectionIsAnimating || sectionReady[6]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const sectionId = '#s-6';
    const section = document.querySelector(sectionId);
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');
    const cards = section.querySelectorAll('.illustration-card .image-wrapper');
    const cardsContents = section.querySelectorAll('.illustration-content > *');

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });

    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[6] = true}});
    linesTL.fromTo(cards, {y:'+=50', autoAlpha:0}, {duration:0.5, y:0, autoAlpha:1, ease:'back.out', stagger:0.08}, 0.5)
        .fromTo(cardsContents, {y:'+=35', autoAlpha:0}, {duration:0.4, y:0, autoAlpha:1, stagger:0.05}, 1.1)
        .fromTo(scroll, {y:200, autoAlpha:0}, {duration:1, y: 0, autoAlpha: 1, ease:'power4.out'}, 1.8)
        .to(scrollLine, {height:30, duration:1, ease:"power4.out"}, 1.9)
    
}

// section 7 animations - image section / COVID-19 screenings
function section7() {

    if (sectionIsAnimating || sectionReady[7]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const sectionId = '#s-7';
    const section = document.querySelector(sectionId);

    const volume = section.querySelector('.stats-years .volume');
    let firstData = initStats(sectionId);

    // Get the core elements
    let clone = section.getElementsByClassName("clone");
    const subtitle = section.querySelectorAll('p.lead');

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });
    gsap.to(document.querySelector(sectionId + " video"), {duration: 0.6, autoAlpha: 1, delay: 1.5}); // shows hero video

    let splitHeader = new SplitText(clone, { type: "chars", charsClass: "char"});
    let splitInfo = new SplitText(sectionId + ' p.info', {type:"words"});
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');
    const stats = section.querySelector('.stats-years');

    // Set up vars
    let animTime = 0.7; // baseline animation time for each stagger
    let width = document.documentElement.clientWidth; // viewport width
    let height = document.documentElement.clientHeight; // viewport height


    // Init 3D perspective
    gsap.set(clone, { perspective:700, transformStyle:"preserve-3d"});
    gsap.set(splitHeader.chars, {transformOrigin: "50% 100%"});

    const bg = section.getElementsByClassName("bg-element");

    const _h1_f = isSmall ? 0 : -height/4-40;
    const _h1_t = isSmall ? 0 : -height/4.5-50;
    
    const _h2_f = isSmall ? 0 : -height/7.5;
    const _h2_t = isSmall ? 0 : -height/7.5-50;

    const _h3_f = isSmall ? 0 : -height/12.8;
    const _h3_t = isSmall ? 0 : -height/12.8-15;


    // Animate Timeline
    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[7] = true}});
    linesTL.fromTo(clone, {y:_h1_f}, {duration:animTime, y:_h1_t, ease:'power2.out'})
        .fromTo(splitHeader.chars, {autoAlpha:0, rotationX:90, y:"-=20"}, {duration:animTime, autoAlpha:1, rotationX:0, y:0, ease:'power4.out', stagger:0.08}, 0)

        .fromTo(subtitle, {autoAlpha: 0, y:_h2_f}, {duration: animTime*2, autoAlpha: 1, y:_h2_t, ease:'power2.out'}, 1.2)
        .fromTo(splitInfo.words, {autoAlpha: 0, y:_h3_f}, {duration: 0.6, autoAlpha: 1, y:_h3_t, stagger: 0.04, ease: 'power2.out'}, 1.6)

        .fromTo(stats, {autoAlpha: 0, y:"+=5"}, {duration: 0.5, autoAlpha: 1, y: 0}, 2.6)
        .counter(volume, {end: firstData, increment: 1, duration: 0.6}, 2.8)
        .from(scroll, {y:200, duration:1, autoAlpha:0, ease:'power4.out'}, 3.4)
        .to(scrollLine, {height:"60%", duration:1, ease:"power4.out"}, 3.5)
        .fromTo(bg, {autoAlpha:0}, {autoAlpha: 1, duration: bgAnimTime, ease:'power4.out'}, 0);
        gsap.delayedCall(3.0, animateStats, [sectionId]);

}

// section 8 animations - image section / Chronic disease patients in care
function section8() {

    if (sectionIsAnimating || sectionReady[8]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const sectionId = '#s-8';
    const section = document.querySelector(sectionId);

    const volume = section.querySelector('.stats-years .volume');
    let firstData = initStats(sectionId);

    // Get the core elements
    let clone = section.getElementsByClassName("clone");
    const subtitle = section.querySelectorAll('p.lead');

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });
    // gsap.to(document.querySelector(sectionId + " video"), {duration: 0.6, autoAlpha: 1, delay: 1.5}); // shows hero video

    let splitHeader = new SplitText(clone, { type: "chars", charsClass: "char"});
    let splitInfo = new SplitText(sectionId + ' p.info', {type:"words"});
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');
    const stats = section.querySelector('.stats-years');

    // Set up vars
    let animTime = 0.7; // baseline animation time for each stagger
    let width = document.documentElement.clientWidth; // viewport width
    let height = document.documentElement.clientHeight; // viewport height


    // Init 3D perspective
    gsap.set(clone, { perspective:700, transformStyle:"preserve-3d"});
    gsap.set(splitHeader.chars, {transformOrigin: "50% 100%"});

    const svgs = section.getElementsByClassName("svg");
    const svg2 = section.getElementsByClassName("svg2");
    const img = section.getElementsByClassName("image");
    const bg = section.getElementsByClassName("bg-element");

    const _h1_f = isSmall ? 0 : -height/4-40;
    const _h1_t = isSmall ? 0 : -height/4.5-50;
    
    const _h2_f = isSmall ? 0 : -height/7.5;
    const _h2_t = isSmall ? 0 : -height/7.5-50;

    const _h3_f = isSmall ? 0 : -height/12.8;
    const _h3_t = isSmall ? 0 : -height/12.8-15;


    // Animate Timeline
    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[8] = true}});
    linesTL.fromTo(clone, {y:_h1_f}, {duration:animTime, y:_h1_t, ease:'power2.out'})
        .fromTo(splitHeader.chars, {autoAlpha:0, rotationX:90, y:"-=20"}, {duration:animTime, autoAlpha:1, rotationX:0, y:0, ease:'power4.out', stagger:0.08}, 0)

        .fromTo(subtitle, {autoAlpha: 0, y:_h2_f}, {duration: animTime*2, autoAlpha: 1, y:_h2_t, ease:'power2.out'}, 1.2)
        .fromTo(splitInfo.words, {autoAlpha: 0, y:_h3_f}, {duration: 0.6, autoAlpha: 1, y:_h3_t, stagger: 0.04, ease: 'power2.out'}, 1.6)

        .fromTo(svgs, {y:"+=15", autoAlpha:0}, {duration: 0.7, y: 0, autoAlpha: 1, stagger: 0.1, ease: 'power4.out'}, 2)
        .fromTo(img, {y:"+5", autoAlpha:0}, {duration:1, y:0, autoAlpha:1, ease:"power4.out"}, 2.2)
        .fromTo(svg2, {autoAlpha:0, rotation:180}, {duration:0.6, autoAlpha:1, rotation:0, ease:'power4.out'}, 2.6)
        .fromTo(stats, {autoAlpha: 0, y:"+=5"}, {duration: 0.5, autoAlpha: 1, y: 0}, 2.6)
        .counter(volume, {end: firstData, increment: 1, duration: 0.6}, 2.8)
        .from(scroll, {y:200, duration:1, autoAlpha:0, ease:'power4.out'}, 3.4)
        .to(scrollLine, {height:"60%", duration:1, ease:"power4.out"}, 3.5)
        .fromTo(bg, {autoAlpha:0}, {autoAlpha: 1, duration: bgAnimTime, ease:'power4.out'}, 0);
        gsap.delayedCall(3.0, animateStats, [sectionId]);

    // Rotate final text on mouse move
    section.addEventListener("mousemove", onMouseMove);

    function onMouseMove(e) {
        let sxPos = (e.pageX / width*100 - 50)*2 ;
        let syPos = (e.pageY / height*100 - 50)*2;
        gsap.to(img, {
            duration: 3,
            rotationY: 0.04 * sxPos,
            // rotationX: -0.04 * syPos,
            transformOrigin: "center center -800",
            ease: 'expo.out'
        });
    }
}

// section 9 animations - voices of PIH section
function section9() {

    if (sectionIsAnimating || sectionReady[9]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    // sectionReady[9] = true;
    const sectionId = '#s-9';
    const section = document.querySelector(sectionId);

    initVoicesCarousel();

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });

    const title = section.querySelector('.story-title');
    const scroll = section.getElementsByClassName("scroll-elipse");
    const scrollLine = section.querySelector('.scroll-element span');
    const bg = section.getElementsByClassName("bg-element");
    const bg2 = section.getElementsByClassName("bg-element2");
    const photosCarousel = section.getElementsByClassName('voices-photos-carousel');
    const quotesCarousel = section.getElementsByClassName('voices-quotes-carousel');

    let voicesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[9] = true}});
    voicesTL.fromTo(title, {x:'+=50', autoAlpha:0}, {duration:0.5, x: 0, autoAlpha: 1, ease:'sine.out'}, 0.2)
        .fromTo(photosCarousel, {y:'+=30', autoAlpha:0}, {duration:0.4, y: 0, autoAlpha: 1, ease:'sine.out'}, 0.4)
        .fromTo(quotesCarousel, {y:'+=30', autoAlpha:0}, {duration:0.4, y: 0, autoAlpha: 1, ease:'sine.out'}, 0.6)
        .from(scroll, {y:200, duration:1, autoAlpha:0, ease:'power4.out'}, 0.8)
        .to(scrollLine, {height:"12%", duration:1, ease:"power4.out"}, 1.0)
        .fromTo(bg, {autoAlpha:0}, {autoAlpha: 1, duration: bgAnimTime, ease:'power4.out'}, 0)
        .fromTo(bg2, {autoAlpha:0}, {autoAlpha: 1, duration: bgAnimTime, ease:'power4.out'}, 0)
}

// section 10 animations - photo stories section
function section10() {

    if (sectionIsAnimating || sectionReady[10]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = true;
    const sectionId = '#s-10';
    const section = document.querySelector(sectionId);
    
    initStories();

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });

    const sTitle = section.querySelector('.section-title');
    const title = section.querySelector('.story-title');
    const date = section.querySelector('.story-date');
    const content = section.querySelector('.story-content');
    const photo = section.querySelector('.story-photo .image-wrapper');
    const credits = section.querySelector('.photo-credits');
    const footer = section.querySelector('.gallery-footer');
    const country = section.querySelector('.country .country-wrapper');
    photo.querySelector('img').classList.add('default');
    country.querySelector('img').classList.add('default');

    const offset = isSmall ? '+=5' : '+=50';

    gsap.fromTo(sTitle, {x:offset, autoAlpha:0}, {duration:0.4, x:0, autoAlpha:1, ease:'sine.out'});
    let storyTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[10] = true}});
    storyTL.fromTo(title, {x:offset, autoAlpha:0}, {duration:0.5, x: 0, autoAlpha: 1, ease:'sine.out'}, 0.2)
        .fromTo(date, {x:offset, autoAlpha:0}, {duration:0.4, x: 0, autoAlpha: 1, ease:'sine.out'}, 0.4)
        .fromTo(content, {x:offset, autoAlpha:0}, {duration:0.4, x: 0, autoAlpha: 1, ease:'sine.out'}, 0.6)
        .fromTo(photo, {x:offset, autoAlpha:0}, {duration:0.4, x: 0, autoAlpha: 1, ease:'sine.out'}, 0.8)
        .fromTo(footer, {y:offset, autoAlpha:0}, {duration:0.4, y: 0, autoAlpha: 1, ease:'sine.out'}, 1.0)
        .fromTo(country, {autoAlpha: 0}, {duration: 1, autoAlpha: 1}, 1.1)
}

// section 11 animations - the-end section
function section11() {

    if (sectionIsAnimating || sectionReady[11]) {
        sectionIsScrolling = false;
        return;
    }
    sectionIsAnimating = false;
    sectionReady[11] = true;
    const sectionId = '#s-11';
    const section = document.querySelector(sectionId);

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });

    // Get the core elements
    let clone = section.getElementsByClassName("clone");
    const btn = section.querySelector('.button');
    const link = section.querySelector('.link');

    // Show it to me!
    gsap.set(sectionId + ' .container', {
        visibility: 'visible'
    });
    // gsap.to(document.querySelector(sectionId + " video"), {duration: 0.6, autoAlpha: 1, delay: 1.5}); // shows hero video

    let splitHeader = new SplitText(clone, { type: "chars", charsClass: "char"});
    let splitInfo = new SplitText(sectionId + ' p.info', {type:"words"});

    // Set up vars
    let animTime = 0.7; // baseline animation time for each stagger
    let width = document.documentElement.clientWidth; // viewport width
    let height = document.documentElement.clientHeight; // viewport height


    // Init 3D perspective
    gsap.set(clone, { perspective:700, transformStyle:"preserve-3d"});
    gsap.set(splitHeader.chars, {transformOrigin: "50% 100%"});

    const _h1_f = isSmall ? 0 : -height/7-40;
    const _h1_t = isSmall ? 0 : -height/7.5-50;

    const _h3_f = isSmall ? 0 : -height/16+50;
    const _h3_t = isSmall ? 0 : -height/16+25;


    // Animate Timeline
    let linesTL = gsap.timeline({onComplete: () => {sectionIsAnimating = false; sectionReady[11] = true}});
    linesTL.fromTo(clone, {y:_h1_f}, {duration:animTime, y:_h1_t, ease:'power2.out'})
        .fromTo(splitHeader.chars, {autoAlpha:0, rotationX:90, y:"-=20"}, {duration:animTime, autoAlpha:1, rotationX:0, y:0, ease:'power4.out', stagger:0.08}, 0)

        .fromTo(splitInfo.words, {autoAlpha: 0, y:_h3_f}, {duration: 0.6, autoAlpha: 1, y:_h3_t, stagger: 0.04, ease: 'power2.out'}, 1.6)

        .fromTo(btn, {y:"+=15", autoAlpha:0}, {duration: 0.7, y: 0, autoAlpha: 1, ease: 'power4.out'}, 1.8)
        .fromTo(link, {autoAlpha:0}, {duration: 0.4, autoAlpha: 1, ease: 'power4.out'}, 1.9)
}

function initStories() {
    const prev = document.querySelector('#s-10 .prev-button');
    const next = document.querySelector('#s-10 .next-button');
    prev.addEventListener('click', prevStory);
    next.addEventListener('click', nextStory);
}

function prevStory(ev) {
    if(playingStories) return;
    playingStories = true;
    
    oldStory = currStory;
    currStory -= 1;
    currStory = currStory < 0 ? stories.length - 1 : currStory;

    const sectionId = '#s-10';
    const section = document.querySelector(sectionId);
    const title = section.querySelector('.story-title h2');
    const date = section.querySelector('.story-date');
    const content = section.querySelector('.story-content');
    const photo = section.querySelector('.story-photo .image-wrapper');
    const credits = section.querySelector('.photo-credits');
    const country = section.querySelector('.country .country-wrapper');

    let tl = gsap.timeline({onComplete:showNextStory});
    tl.to(title, {duration:0.2, x:'+=30', autoAlpha: 0, ease:'sine.in'}, 0)
        .to(country, {duration: 0.2, autoAlpha: 0}, 0)
        .to(date, {duration:0.2, x:'+=30', autoAlpha: 0, ease:'sine.in'}, 0.1)
        .to(content, {duration:0.2, x:'+=30', autoAlpha: 0, ease:'sine.in'}, 0.2)
        .to(photo, {duration:0.3, x:'+=30', autoAlpha: 0, ease:'sine.in'}, 0.3)
        .to(credits, {duration:0.3, x:'+=30', autoAlpha: 0, ease:'sine.in'}, 0.3)
}
function nextStory(ev) {
    if(playingStories) return;
    playingStories = true;

    oldStory = currStory;
    currStory += 1;
    currStory = currStory > stories.length - 1 ? 0 : currStory;

    const sectionId = '#s-10';
    const section = document.querySelector(sectionId);
    const title = section.querySelector('.story-title h2');
    const date = section.querySelector('.story-date');
    const content = section.querySelector('.story-content');
    const photo = section.querySelector('.story-photo .image-wrapper');
    const credits = section.querySelector('.photo-credits');
    const country = section.querySelector('.country .country-wrapper');

    let tl = gsap.timeline({onComplete:showNextStory});
    tl.to(title, {duration:0.2, x:'-=30', autoAlpha: 0, ease:'sine.in'}, 0)
        .to(country, {duration: 0.2, autoAlpha: 0}, 0)
        .to(date, {duration:0.2, x:'-=30', autoAlpha: 0, ease:'sine.in'}, 0.1)
        .to(content, {duration:0.2, x:'-=30', autoAlpha: 0, ease:'sine.in'}, 0.2)
        .to(photo, {duration:0.3, x:'-=30', autoAlpha: 0, ease:'sine.in'}, 0.3)
        .to(credits, {duration:0.3, x:'-=30', autoAlpha: 0, ease:'sine.in'}, 0.3)
}
function showNextStory() {
    const sectionId = '#s-10';
    const section = document.querySelector(sectionId);
    const title = section.querySelector('.story-title h2');
    const date = section.querySelector('.story-date');
    const content = section.querySelector('.story-content');
    const photo = section.querySelector('.story-photo .image-wrapper');
    const credits = section.querySelector('.photo-credits');
    const country = section.querySelector('.country .country-wrapper');
    title.innerHTML = stories[currStory].title;
    date.innerHTML = stories[currStory].date;
    content.innerHTML = stories[currStory].content;
    photo.querySelector('.default').src = stories[currStory].photo;
    credits.innerHTML = stories[currStory].credits;
    country.querySelector('.default').src = stories[currStory].country;
    const pg = document.querySelector('.story-pagination .current-story');
    pg.innerText = '0' + (currStory + 1);

    let tl = gsap.timeline({onComplete: () => {playingStories = false;}});
    tl.to(title, {duration:0.3, x:0, autoAlpha:1, ease:'sine.out'}, 0)
        .to(date, {duration:0.3, x:0, autoAlpha:1, ease:'sine.out'}, 0.1)
        .to(content, {duration:0.3, x:0, autoAlpha:1, ease:'sine.out'}, 0.2)
        .to(photo, {duration:0.4, x:0, autoAlpha:1, ease:'sine.out'}, 0.3)
        .to(credits, {duration:0.3, x:0, autoAlpha: 1, ease:'sine.out'}, 0.3)
        .to(country, {duration: 0.3, autoAlpha: 1}, 0.4)
}

require('@fancyapps/fancybox');

const stories = [
    {
        title: 'PERU',
        date: 'January 2021',
        content: '<p>Sol Prieto connects with clinicians about her toddler&apos;s health using the CASITA chatbot, one of the seven mobile health apps PIH developed to easily connect patients with care.</p>',
        photo: 'assets/img/story-peru.jpg',
        credits: 'Photo by Melissa Estefany Toledo Soldevilla / PIH',
        country: 'assets/img/pe-03.svg',
    },
    {
        title: 'SIERRA LEONE',
        date: 'February 2021',
        content: '<p>Saffiatu Sesay, 27, was cured of multidrug-resistant tuberculosis at PIH-supported Lakka Government Hospital. Inspired by this care, she dreams of becoming a nurse.</p>',
        photo: 'assets/img/story-siera-leone.jpg',
        credits: 'Photo by Maya Brownstein / PIH',
        country: 'assets/img/sl-03.svg',
    },
    {
        title: 'UNITED STATES',
        date: 'March 2021',
        content: '<p>Supporters of the People&apos;s Vaccine movement hold a rally against vaccine apartheid in Cambridge, MA, which is home to biomedical and pharmaceutical companies.</p>',
        photo: 'assets/img/story-us.jpg',
        credits: 'Photo by Zack DeClerck / PIH',
        country: 'assets/img/us-03.svg',
    },
    {
        title: 'HAITI',
        date: 'August 2021',
        content: '<p>Patients injured in the August 14 earthquake in southern Haiti arrived via air ambulance to University Hospital in Mirebalais, where they received specialty emergency care.</p>',
        photo: 'assets/img/story-haiti.jpg',
        credits: 'Photo by Nadia Todres for PIH',
        country: 'assets/img/ht-03.svg',
    },
    {
        title: 'MEXICO',
        date: 'August 2021',
        content: '<p>Gladys Arias Ruiz received inpatient care for COVID-19 and successfully recovered from the virus. Upon discharge, she was walked out by nurse Carlos Coello and met by her husband.</p>',
        photo: 'assets/img/story-mexico.jpg',
        credits: 'Photo by Paola Rodríguez / PIH',
        country: 'assets/img/mx-03.svg',
    },
    {
        title: 'RWANDA',
        date: 'December 2021',
        content: '<p>The first cohort of medical students at the University of Global Health Equity celebrated their white coat ceremony, signifying the start of their clinical rotations.</p>',
        photo: 'assets/img/story-rwanda.jpg',
        credits: 'Photo courtesy of UGHE',
        country: 'assets/img/rw-03.svg',
    },
];

const preloadImage = src => 
    new Promise(r => {
        const image = new Image();
        image.onload = r;
        image.onerror = r;
        image.src = src;
    })
Promise.all(stories.map(x => preloadImage(x.photo)));
